<template>
  <div id="projects">
    <el-tabs type="border-card" v-model="tab">
      <el-tab-pane label="项目列表" name="1"></el-tab-pane>
      <el-tab-pane label="添加项目" name="2"></el-tab-pane>
    </el-tabs>
    <div style="background-color:#fff">
      <div v-if="tab==1" style="padding: 30px">
        <div v-if="p_list&&p_list.length==0" class="lv3Text" align="center">
          未创建项目,
          <el-link type="primary" @click="tab=2">去创建</el-link>
        </div>
        <div v-for="(item,index) of p_list" :key="index" style="margin-bottom:35px;">
          <el-row>
            <el-col :span="12" class="t1">
              <div class="lv2Text">
                <i class="fas fa-flask fa-lg" style="color:#409EFF"></i>
                {{item.project_name}}
                <span
                  class="lv3Text"
                  style="font-size:13px"
                >项目编号：{{item.project_no}}</span>
              </div>
            </el-col>
            <el-col :span="12" align="right">
              <div class="lv3Text">
                <router-link :to="'/user/viewProject?id='+item.id">
                  <el-button type="text" size="small" style="margin-right:15px">查看</el-button>
                </router-link>
                <el-popover placement="top" width="160" v-model="visibles[index]">
                  <p>确定删除吗？</p>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="text" @click="cancel(index)">取消</el-button>
                    <el-button type="primary" size="mini" @click="del(item.id,index)">确定</el-button>
                  </div>
                  <el-button type="text" slot="reference" size="small">删除</el-button>
                </el-popover>
              </div>
            </el-col>
          </el-row>
          <el-table :data="[item]" style="width: 100%" border>
            <el-table-column label="总金额" width="120">
              <template slot-scope="scope">&yen; {{scope.row.project_money}}</template>
            </el-table-column>
            <el-table-column label="试剂">
              <template slot-scope="scope">&yen; {{scope.row.reagent}}</template>
            </el-table-column>
            <el-table-column label="抗体">
              <template slot-scope="scope">&yen; {{scope.row.antibody}}</template>
            </el-table-column>
            <el-table-column label="耗材">
              <template slot-scope="scope">&yen; {{scope.row.consume}}</template>
            </el-table-column>
            <el-table-column label="设备">
              <template slot-scope="scope">&yen; {{scope.row.facility}}</template>
            </el-table-column>
            <el-table-column label="技术服务">
              <template slot-scope="scope">&yen; {{scope.row.technical_service}}</template>
            </el-table-column>
            <el-table-column label="其他">
              <template slot-scope="scope">&yen; {{scope.row.others}}</template>
            </el-table-column>
          </el-table>
          <div
            class="lv3Text end-date"
          >结束日期：{{dayjs(_.toInteger(item.end_time)).format("YYYY-MM-DD")}}</div>
        </div>
      </div>
      <div v-if="tab==2" style="padding: 30px 0">
        <div class="form">
          <el-form label-position="right" label-width="140px" :model="form">
            <el-form-item label="项目编号：">
              <el-input v-model="form.project_no"></el-input>
            </el-form-item>
            <el-form-item label="项目名称：">
              <el-input v-model="form.project_name"></el-input>
            </el-form-item>
            <el-form-item label="项目总金额：">
              <el-input v-model="form.project_money" class="i1"></el-input>元
            </el-form-item>
            <el-form-item label="经费来源：">
              <el-input v-model="form.money_source"></el-input>
            </el-form-item>
            <el-form-item label="项目期限：">
              <el-date-picker
                @change="setTime"
                v-model="form.time"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="timestamp"
              ></el-date-picker>
            </el-form-item>
            <div class="lv3Text" style="padding:20px 10px;margin-top:-10px;">预算金额</div>
            <el-form-item label="试剂：">
              <el-input v-model="form.reagent" class="i1"></el-input>元
            </el-form-item>
            <el-form-item label="耗材：">
              <el-input v-model="form.consume" class="i1"></el-input>元
            </el-form-item>
            <el-form-item label="抗体：">
              <el-input v-model="form.antibody" class="i1"></el-input>元
            </el-form-item>
            <el-form-item label="设备：">
              <el-input v-model="form.facility" class="i1"></el-input>元
            </el-form-item>
            <el-form-item label="技术服务：">
              <el-input v-model="form.technical_service" class="i1"></el-input>元
            </el-form-item>
            <el-form-item label="其他：">
              <el-input v-model="rest" disabled class="i1"></el-input>元
            </el-form-item>
            <el-form-item label="项目负责人：">
              <el-input v-model="form.charge_name"></el-input>
            </el-form-item>

            <el-form-item label="合作单位及负责人：">
              <div>
                <el-row :gutter="10">
                  <el-col :span="20">
                    <div class="i1" v-if="inputs>0">
                      <el-input v-model="form.cooperator0"></el-input>
                    </div>
                    <div class="i1" v-if="inputs>1">
                      <el-input v-model="form.cooperator1"></el-input>
                    </div>
                    <div class="i1" v-if="inputs>2">
                      <el-input v-model="form.cooperator2"></el-input>
                    </div>
                    <div class="i1" v-if="inputs>3">
                      <el-input v-model="form.cooperator3"></el-input>
                    </div>
                    <div class="i1" v-if="inputs>4">
                      <el-input v-model="form.cooperator4"></el-input>
                    </div>
                  </el-col>
                  <el-col :span="3">
                    <div>
                      <el-button icon="el-icon-plus" circle @click="inputs++" v-if="inputs<5"></el-button>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-form-item>
          </el-form>
          <div align="center">
            <el-button type="primary" style="width: 150px;" :loading="loading" @click="submit">提交</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //
      serve: this.$store.state.serve,

      form: {
        reagent: "",
        consume: "",
        antibody: "",
        facility: "",
        technical_service: "",
        start_time: "",
        end_time: "",
        time: [],
        cooperator: "",
        cooperator0: "",
        cooperator1: "",
        cooperator2: "",
        cooperator3: "",
        cooperator4: ""
      },
      inputs: 1,
      loading: false,
      mobile: this.$cookies.get("user"),
      token: this.$cookies.get("token"),
      tab: "1",
      p_list: null,
      visibles: []
    };
  },
  watch: {
    tab: function(val) {
      //
    }
  },
  computed: {
    rest: function() {
      let value = _.subtract(this.form.project_money, this.form.reagent);
      value = _.subtract(value, this.form.consume);
      value = _.subtract(value, this.form.antibody);
      value = _.subtract(value, this.form.facility);
      value = _.subtract(value, this.form.technical_service);
      return value;
    }
  },
  created() {
    //
    this.$store.state.user_location = "我的项目";
    this.$store.state.leftMenuIndex = 9;
    this.initList();
  },
  methods: {
    //
    cancel(index) {
      this.$set(this.visibles, index, false);
    },
    del(id, index) {
      const loading = this.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)"
      });
      this.axios
        .get(this.serve + "/personal/del_project", {
          params: {
            mobile: this.mobile,
            token: this.token,
            id: id
          }
        })
        .then(res => {
          if ((res.data.status = "success")) {
            loading.close();
            this.$set(this.visibles, index, false);
            this.initList();
            this.$message("项目已删除");
          }
        });
    },
    initList() {
      this.axios
        .get(this.serve + "/personal/my_project_list", {
          params: {
            mobile: this.mobile,
            token: this.token
          }
        })
        .then(res => {
          if ((res.data.status = "success")) {
            this.p_list = res.data.data;
          }
        });
    },
    submit() {
      this.loading = true;
      if (this.form.cooperator0 != "") {
        this.form.cooperator =
          this.form.cooperator + ";" + this.form.cooperator0;
      }
      if (this.form.cooperator1 != "") {
        this.form.cooperator =
          this.form.cooperator + ";" + this.form.cooperator1;
      }
      if (this.form.cooperator2 != "") {
        this.form.cooperator =
          this.form.cooperator + ";" + this.form.cooperator2;
      }
      if (this.form.cooperator3 != "") {
        this.form.cooperator =
          this.form.cooperator + ";" + this.form.cooperator3;
      }
      if (this.form.cooperator4 != "") {
        this.form.cooperator =
          this.form.cooperator + ";" + this.form.cooperator4;
      }
      this.form.mobile = this.mobile;
      this.form.token = this.token;
      this.form.others = this.rest;
      this.axios
        .get(this.serve + "/personal/add_my_project", {
          params: this.form
        })
        .then(res => {
          if (res.data.status == "success") {
            this.loading = false;
            this.$message({
              message: "项目添加完成",
              type: "success"
            });
          } else if (res.data.msg == "最多添加5个项目") {
            this.loading = false;
            this.$message.error("最多添加5个项目");
          }
        });
    },
    setTime(v) {
      this.form.start_time = v[0];
      this.form.end_time = v[1];
    }
  }
};
</script>
<style lang="scss">
#projects {
  .i1{
    width: 80%;
    margin-right:10px;
  }
  .el-tabs--border-card {
    border: 0;
    box-shadow: none;
  }
  .end-date {
    padding: 20px 0;
    text-align: right;
    font-size: 13px;
  }
  .form {
    width: 40%;
    margin: 0 auto;
  }
  .i1 {
    margin-bottom: 10px;
  }
  .t1 {
    margin-bottom: 10px;
  }
}
</style>